import React, { useState, useEffect } from "react";

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';

import Logo from './logo.png';

const BottomBar = ({ sendMessage, notification, setNotification, editable }) => {

    const countdownInitialDate = new Date();

    // Set the time to 45 minutes from the start of the day
    countdownInitialDate.setHours(0);
    countdownInitialDate.setMinutes(45);
    countdownInitialDate.setSeconds(0);
    countdownInitialDate.setMilliseconds(0);

    const [editCountdown, setEditCountdown] = useState(countdownInitialDate);
    const [countdown, setCountdown] = useState("00:00:00");
    const [live, setLive] = useState(false);
    const [editCountdownDialog, setEditCountdownDialog] = useState(false);
    const [time, setTime] = useState('00:00:00');

    useEffect(() => {
        if (notification.type === "update") {
            setTime(notification.time)
            setCountdown(notification.countdown)
            if (live !== notification.live) {
                setLive(notification.live)
            }
        }
        else if (notification.type === "state_changed") {
            if (notification.state)
                setLive(true)
            else
                setLive(false)
        }
        else if (notification.type === "countdown_edited") {
            const dateObject = new Date(notification.time);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();

            // Format hours, minutes, and seconds to ensure they have leading zeros if necessary
            const formattedHours = hours.toString().padStart(2, '0');
            const formattedMinutes = minutes.toString().padStart(2, '0');
            const formattedSeconds = seconds.toString().padStart(2, '0');

            setCountdown(`${formattedHours}:${formattedMinutes}:${formattedSeconds}`);
        }
    }, [notification])

    const hideEditCountdownDialog = () => {
        setEditCountdownDialog(false);
    };

    const showEditCountdownDialog = () => {
        setEditCountdownDialog(true)
    }

    const saveCountdown = () => {
        sendMessage(JSON.stringify({ type: "countdown_edited", time: editCountdown.toString() }))
        setNotification({ type: "countdown_edited", time: editCountdown.toString() })
        setEditCountdownDialog(false);
    }

    const editCountdownDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={hideEditCountdownDialog} />
            <Button label="Save" icon="pi pi-check" onClick={saveCountdown} className="m-0" />
        </React.Fragment>
    );

    const liveButtonClick = () => {
        sendMessage(JSON.stringify({ type: "state_changed", state: !live }))
        setNotification({ type: "state_changed", state: !live })
    }

    return (
        <>
            {!editable && <img className="hidden lg:inline-flex w-auto min-h-full" style={{height: "50px"}} src={Logo} alt="My Image" />}
            <div style={{flex: "1 1 0px"}}></div>
            <span className="m-0 text-6xl font-bold flex align-items-center gap-2" style={{ fontFamily: "Chivo Mono, monospace" }}><i className="pi pi-clock text-5xl"></i>{time}</span>
            <span onClick={showEditCountdownDialog} className="m-0 text-6xl font-bold flex align-items-center gap-2 cursor-pointer" style={{ fontFamily: "Chivo Mono, monospace" }}><i className="pi pi-stopwatch text-5xl"></i>{countdown}</span>
            <Button label={live ? "LIVE!" : "OFFLINE!"} severity={live ? "danger" : "secondary"} onClick={(e) => liveButtonClick()} className="w-9rem" />

            <Dialog visible={editCountdownDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Edit Countdown" modal footer={editCountdownDialogFooter} onHide={hideEditCountdownDialog} draggable={false}>
                <Calendar className="w-full" value={editCountdown} onChange={(e) => setEditCountdown(e.target.value)} inline timeOnly showSeconds />
            </Dialog>
        </>
    );
}

export default BottomBar;